import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import SupplierForm from './SupplierForm';
import { createSupplier } from '../../collections/suppliers';

const CreateSupplier = () => {
  const navigate = useNavigate();

  const handleCreateSupplier = async (formData) => {
    try {
      await createSupplier(formData);
      toast.success('Tạo nhà cung cấp thành công!', {
        position: 'top-center',
        autoClose: 2000,
      });
      // Assuming you have a suppliers list page to navigate to
      navigate('/suppliers');
    } catch (error) {
      let errorMessage = "Đã xảy ra lỗi không xác định!";
      if (error.response?.data?.error) {
        // Concatenate all error messages from the backend
        errorMessage = Object.values(error.response.data.error).flat().join('; ');
      }
      toast.error(errorMessage, {
        position: 'top-center',
        autoClose: 3000,
      });
    }
  };

  return <SupplierForm onSubmit={handleCreateSupplier} />;
};

export default CreateSupplier; 